<template>
    <div class="title-block">
        <div class="title-block__left flex-column align-items-start flex-lg-row align-items-lg-center">
            <a :href="route_create_page" class="title-block__btn btn-add btn-primary btn">Добавить лицензию</a>
            <a :href="route_create_report" class="title-block__btn btn-outline-primary btn">
                Сформировать документы
            </a>
        </div>
    </div>

    <div class="filter-table">
        <div class="filter-table__input-wrap search-control">
            <input type="text" class="search-control__input form-control" placeholder="Поиск">
            <button class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5" stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <div class="filter-table__list-wrap">
            <ul class="filter-table__list">
                <li class="filter-table__item">
                    <v-select v-model="client"
                        :options="clients"
                        @update:modelValue="onChangeClient"
                        :searchable="false"
                        :reduce="name => name.id" label="name"
                        :deselectFromDropdown="false"
                        :appendToBody="true"
                        :calculate-position="withPopper"
                        :clearable="false"
                        class="ftoggle">
                    </v-select>
                </li>

                <li class="filter-table__item">
                    <v-select v-model="brand"
                        :options="brands"
                        @update:modelValue="onChangeBrand"
                        :reduce="name => name.id" label="name"
                        :searchable="false"
                        :deselectFromDropdown="false"
                        :appendToBody="true"
                        :calculate-position="withPopper"
                        :clearable="false"
                        class="ftoggle">
                    </v-select>
                </li>

                <li class="filter-table__item">
                    <v-select v-model="device"
                        :options="deviceTypes"
                        @update:modelValue="onChangeDeviceType"
                        :reduce="name => name.id" label="name"
                        :searchable="false"
                        :deselectFromDropdown="false"
                        :appendToBody="true"
                        :calculate-position="withPopper"
                        :clearable="false"
                        class="ftoggle" >
                    </v-select>
                </li>

                <li class="filter-table__item">
                    <v-select v-model="state"
                        :options="states"
                        @update:modelValue="onChangeState"
                        :reduce="name => name.id" label="name"
                        :searchable="false"
                        :deselectFromDropdown="false"
                        :appendToBody="true"
                        :calculate-position="withPopper"
                        :clearable="false"
                        class="ftoggle" >
                    </v-select>
                </li>
            </ul>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>
                        <div class="form-check" title="Выбрать все">
                            <input @input="addAllToSelected()" class="form-check-input" type="checkbox">
                        </div>
                    </th>
                    <th>Номер&nbsp;аптеки</th>
                    <th>Клиент</th>
                    <th>Организация</th>
                    <th>Адрес</th>
                    <th>Устройство</th>
                    <th>Статус и&nbsp;срок лицензии</th>
                    <th>Статус&nbsp;оплаты</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="license in licenses">
                    <td>
                        <div class="form-check">
                            <input :checked="license.selected" @input="addToSelected(license)" class="form-check-input" type="checkbox">
                        </div>
                    </td>
                    <td>{{ license.pharmacy_number }}</td>
                    <td>{{ license.client }}</td>
                    <td>{{ license.organization }}</td>
                    <td>{{ license.address }}</td>
                    <td>{{ license.type }} {{ license.item }}</td>
                    <td>
                        <div v-if="license.status">
                            <div v-if="statusDetermination(license)" class="table-state bg-lighten-blue">
                                <div v-if="!expirationDetermination(license)">
                                    Действует до {{ license.expires_at }}
                                </div>
                                <div v-if="expirationDetermination(license)">
                                    Истекает менее чем через 30 дней
                                </div>
                            </div>
                            <div v-if="!statusDetermination(license)" class="table-state bg-lighten-gray">
                                Не действует с {{ license.expires_at }}
                            </div>
                        </div>
                        <div v-if="!license.status" class="table-state bg-lighten-gray">
                            Не действует с {{ license.expires_at }}
                        </div>
                    </td>
                    <td>
                        <span class="table-state" v-bind:class="{'bg-salad': license.status_payment === 3, 'bg-salmon': license.status_payment !== 3}">
                            {{ license.status_payment === 1 ? 'Не оплачено' : (license.status_payment === 2 ? 'Выставлен счет' : license.status_payment === 3 ? 'Оплачено' : '') }}
                        </span>
                    </td>
                    <td>
                        <div class="table-actions">
                            <a :href="route_edit_page + license.id" type="button" class="table-action table-action_edit" title="Редактировать"></a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <pagination-element :count="licenses.count" :current_page="page" @pageChange="pageChange"></pagination-element>

    <Alert />

</template>

<script>
import { withPopper } from '../../../../utilites';
import PaginationElement from '../../../../elements/PaginationElement.vue'
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "LicenseComponent",
    components: {
        PaginationElement,
        Alert,
    },
    props: {
        route_create_page: String,
        route_create_report: String,
        route_edit_page: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_update: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            searchDateCreatedFrom: '',
            searchDateCreatedTo: '',
            searchDateEndFrom: '',
            searchDateEndTo: '',
            actions: [],
            tbody: [],
            limit: 10,
            page: 1,
            selected: false,
            selectedAll: false,
            licenses: [],
            clients: [],
            brands: [],
            deviceTypes: [],
            selectedDeviceType: null,
            selectedClient: null,
            selectedBrand: null,
            selectedStatus: null,
            search: null,
            client: 'Клиент',
            brand: 'Бренд',
            device: 'Тип устройства',
            state: 'Статус лицензии',
            devices_types: [],
            states: [
                {
                    id: 0,
                    name: 'Все'
                },
                {
                    id: 1,
                    name: 'Действующие'
                },
                {
                    id: 2,
                    name: 'Недействующие'
                },
                {
                    id: 3,
                    name: 'Истекающий срок'
                },
            ],
        };
    },
    watch: {
        ...mapMutations('alerts', ['addAlert']),
        async selectedClient(val) {
            if (!val) {
                this.selectedBrand = null
            }

            const data = await axios.get('/organizational/brands/list', {
                params: {
                    page: 1,
                    limit: 100,
                    client_id: val
                }
            }).then(response => {
                return response.data.status === 'ok' ? response.data.items : false
            });

            if (data) {
                this.brands = data;
            }

            await this.listLicenses();
        },
    },
    methods: {
        withPopper,
        listClients: async function () {
            const data = await axios.get('/organizational/client/list', {}).then(response => {
                return response.data.status === 'ok' ? response.data.items : false
            });

            if (data) {
                this.clients = data;
            }
        },
        listDevicesTypes: async function () {
            const data = await axios.get('/technical/device-types/list', {}).then(response => {
                return response.data.status === 'ok' ? response.data.items : false
            });

            if (data) {
                this.deviceTypes = data;
            }
        },
        listLicenses: async function() {
            let response = await axios.get('/documents/licenses/list', {params: {
                    page: this.page,
                    limit: this.limit,
                    search: this.search,
                    end_from: this.searchDateEndFrom,
                    end_to: this.searchDateEndTo,
                    created_from: this.searchDateCreatedFrom,
                    created_to: this.searchDateCreatedTo,
                    client_id: this.selectedClient,
                    brand_id: this.selectedBrand,
                    type_id: this.selectedDeviceType,
                    status: this.selectedStatus
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список лицензий, что-то пошло не так' });
            });

            if (response.data.status == 'ok') {
                this.licenses = response.data.items;
                this.licenses.count = response.data.pages;
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.listLicenses();
        },
        statusDetermination: function (license) {
            const today = new Date();
            const exp = new Date(license.expires_at);
            return today <= exp;
        },
        expirationDetermination: function (license) {
            const today = new Date();
            const exp = new Date(license.expires_at);
            const expDay = (exp - today) / (60 * 60 * 24 * 1000);
            return expDay < 30;
        },
        addToSelected: function (license) {
            license.selected = !license.selected;

            const found = this.licenses.filter((el) => el.selected);

            this.selected = found.length > 0;
        },
        addAllToSelected: function() {
            this.selectedAll = !this.selectedAll

            if (this.selectedAll) {
                this.licenses = this.licenses.map((el) => {
                    el.selected = true
                    return el
                })
            }

            if (!this.selectedAll) {
                this.licenses = this.licenses.map((el) => {
                    el.selected = false
                    return el
                })
            }

            const found = this.licenses.filter((el) => el.selected).map((el) => el.id)

            this.selected = found.length > 0
        },
        onChangeClient: async function (client_id) {
            this.selectedClient = client_id;
            this.listLicenses();
        },
        onChangeBrand: async function (brand_id) {
            this.selectedBrand = brand_id;
            this.listLicenses();
        },
        onChangeDeviceType: async function (device_type_id) {
            this.selectedDeviceType = device_type_id;
            this.listLicenses();
        },
        onChangeState: async function (state_id) {
            if (state_id === 0) {
                this.selectedStatus = null;
            }
            this.selectedStatus = state_id
            this.listLicenses();
        },
    },
    mounted () {
        this.listClients();
        this.listLicenses();
        this.listDevicesTypes();
    }
};
</script>

<style></style>
